import React, { useContext } from "react";

import "./simpl-modal-style.scss";
import { DeviceContext, deviceType } from '@providers';

import BasicModal from "@src/componentsNew/Modals/BasicModal/BasicModal";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const SimplModal = ({ open, onClose }: IProps) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    <BasicModal
      modalId="detail-simpl-modal"
      cName={isMobile ? 'mobile' : 'desktop'}
      content={
        <img className="simpl-image" src={"https://cdn.getsimpl.com/images/pay_in_3/interstitial_1.jpg"} />
      }
      open={open}
      onClose={onClose}
      showCloseIcon={true}
    />
  )
}

export default SimplModal;
